module.exports = {
  localeName: 'es-MX',
  momentFormat: 'DD/MM/YYYY',
};
